import { useInventarioInicial } from "../contexto/provider/InventarioInicialContext.js";

export function useInventarioInicialActualizado() {

  const { inventarioInicial, loading, listarInventarioInicial } = useInventarioInicial();

const inventarioNormalizado = (inventarioInicial || []).map(item => ({
    id: item.id_inventario,
    nombre: item.productos_precio?.nombre || "Sin nombre",
    cantidad: item.stock_apertura,
    stock_apertura: item.stock_apertura,
    bloqueado: item.bloqueado === true
  }));
  // 🔹 fuerza recarga desde BD
  const recargarDesdeBD = async () => {
    await listarInventarioInicial({ fuerza: true });
  };

  return {
    inventarioInicial: inventarioNormalizado,
    loading,
    listarInventarioInicial: listarInventarioInicial,
    recargarDesdeBD
  };
}
